import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=40eede49&scoped=true&"
import script from "./Basic.vue?vue&type=script&lang=js&"
export * from "./Basic.vue?vue&type=script&lang=js&"
import style0 from "./Basic.vue?vue&type=style&index=0&id=40eede49&prod&lang=css&"
import style1 from "./Basic.vue?vue&type=style&index=1&id=40eede49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eede49",
  null
  
)

export default component.exports